if (document.querySelector('#hero_videos')) {
  var hero_videos = new Splide('#hero_videos', {
    type: 'loop',
    pauseOnHover: false,
    arrows: false,
    pagination: false,
    speed: 1000,
    centerMode: false,
    perPage: 1,
    width: '340px',
    focus: 'left',
    lazyLoad: 'nearby',
  });
  hero_videos.mount();
  document.querySelectorAll('[slide-id="' + 1 + '"]').forEach((elem) => {
    elem.classList.add('active');
  });

  let all_videos = document.querySelectorAll('.hero-video');
  hero_videos.on('move', function (newIndex, oldIndex, destIndex) {
    // Hiding animation
    document.querySelector('.home-hero h1').classList.add('hide_animate');
    document.querySelector('.home-hero .subtitle').classList.add('hide_animate');
    document.querySelector('.home-hero .bg_title').classList.add('hide_animate');

    setTimeout(() => {
      document.querySelector('.home-hero h1').classList.remove('hide_animate');
      document.querySelector('.home-hero .subtitle').classList.remove('hide_animate');
      document.querySelector('.home-hero .bg_title').classList.remove('hide_animate');

      document.querySelector('#changing_title').innerHTML = all_videos[newIndex + 2].getAttribute('data-title');
      document.querySelector('.home-hero .bg_title').innerHTML = all_videos[newIndex + 2].getAttribute('data-title');
      // document.querySelector('#bg_title_img').src = all_videos[newIndex + 2].getAttribute('bg-link');
      document.querySelector('#changing_link_button').href = all_videos[newIndex + 2].getAttribute('collection-link');
    }, 500);

    all_videos.forEach((elem) => {
      elem.classList.remove('active');
      elem.querySelector('video').pause();
    });
    all_videos[newIndex + 2].classList.add('active');
    all_videos[newIndex + 2].querySelector('video').play();
  });

  setTimeout(() => {
    hero_videos.go(1);
  }, 500);

  document.querySelector('.hero-videos .prev').addEventListener('click', function () {
    hero_videos.go('-1');
  });
  document.querySelector('.hero-videos .next').addEventListener('click', function () {
    hero_videos.go('+1');
  });
}

if (document.querySelector('#product__collection__carousel')) {
  var collection_carousel = new Splide('#product__collection__carousel', {
    pauseOnHover: false,
    arrows: false,
    pagination: false,
    speed: 500,
    centerMode: false,
    perPage: 4,
    perMove: 1,
    gap: '32px',
    focus: 'left',
    trimSpace: true,
    breakpoints: {
      1024: {
        perPage: 2,
      },
      600: {
        perPage: 1,
      },
    },
  });
  collection_carousel.mount();

  if (document.querySelector('.custom_collection .carousel__button--prev')) {
    document.querySelector('.custom_collection .carousel__button--prev').addEventListener('click', function () {
      collection_carousel.go('-1');
    });
  }
  if (document.querySelector('.custom_collection .carousel__button--next')) {
    document.querySelector('.custom_collection .carousel__button--next').addEventListener('click', function () {
      collection_carousel.go('+1');
    });
  }
}
